const toCurrency = value =>
  Number(value)
    .toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    })
    .replace(/\s/, " ");

export default toCurrency;
